import debounce from "lodash.debounce";
import get from "lodash.get";
import axios from "axios";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      loggedUser: (state) => state.loggedUser,
    }),
  },
  methods: {
    debounceValidation: debounce(async function validaSeValorJaFoiRegistrado({
      valorAtual,
      valorDoCampoOriginal = null,
      nomeDoArrayDeErros,
      nomeDoLoader,
      servico,
      mensagemDeErro404 = "Nenhum item registrado com este valor.",
      mensagemDeErro409 = "Já existe um item registrado com este valor.",
    } = {}) {
      console.table(arguments);
      if (
        valorAtual === undefined ||
        valorAtual === "" ||
        valorAtual === valorDoCampoOriginal
      ) {
        this[nomeDoArrayDeErros] = [];
        return;
      }
      this[nomeDoLoader] = true;
      try {
        await axios({
          method: "get",
          url: `${servico}${valorAtual}`,
          responseType: "json",
          headers: {
            Authorization: `Bearer ${this.loggedUser.token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });
        this[nomeDoLoader] = false;
      } catch (error) {
        if (
          get(error, "response.status", null) === null ||
          get(error, "response.status", null) === 404
        ) {
          if (this[nomeDoArrayDeErros].length >= 0) {
            console.error(mensagemDeErro404);
            console.error(error);
            this[nomeDoArrayDeErros] = [];
            this.isValid = true;
          }
          this[nomeDoLoader] = false;
        } else if (error.response.status === 409) {
          if (this[nomeDoArrayDeErros].length === 0) {
            console.error(mensagemDeErro409);
            console.error(error);
            this[nomeDoArrayDeErros].push(mensagemDeErro409);
          }
          this[nomeDoLoader] = false;
        } else {
          console.error("Erro");
          console.error(error);
          this[nomeDoLoader] = false;
        }
      }
    },
    500),
    novoDebounceValidacao: debounce(async function verificaValorDocumento(
      novoValor
    ) {
      let vm = this;

      if (
        this.verificaPerfilFinanceiro &&
        this.solicitacao.fornecedor.tipo !== "FornecedorFisico"
      ) {
        vm.loadingValidacao = true;
        await axios({
          method: "get",
          url: `/validacao/pagamento?pedido=${novoValor.$event}&fornecedor=${
            this.solicitacao.fornecedor.id
          }`,
          responseType: "json",
          headers: {
            Authorization: `Bearer ${this.loggedUser.token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
          .then(function(response) {
            if (response.data) {
              vm.solicitacao.pagamentoEstaLiberado = true;
            } else {
              vm.solicitacao.pagamentoEstaLiberado = false;
            }
          })
          .catch(function(error) {
            vm.loadingValidacao = false;
          });
      } else if (
        this.verificaPerfilFinanceiro &&
        this.solicitacao.fornecedor.tipo === "FornecedorFisico"
      ) {
        vm.solicitacao.pagamentoEstaLiberado = true;
      }

      vm.loadingValidacao = false;
    },
    500),
    debounceValidacao: debounce(async function verificaValorDocumento(
      novoValor
    ) {
      if (this.verificaPerfilFinanceiro) {
        let vm = this;
        vm.loadingValidacao = true;
        if (this.viewRequest.fornecedor.tipo == "FornecedorJuridico") {
          await axios({
            method: "get",
            url: `/validacao/pagamento?pedido=${novoValor.$event}&cnpj=${
              this.viewRequest.fornecedor.cnpj
            }`,
            responseType: "json",
            headers: {
              Authorization: `Bearer ${this.loggedUser.token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          })
            .then(function(response) {
              if (response.data) {
                vm.viewRequest.pagamentoEstaLiberado = true;
              } else {
                vm.viewRequest.pagamentoEstaLiberado = false;
              }
              vm.loadingValidacao = false;
            })
            .catch(function(error) {
              vm.loadingValidacao = false;
            });
        } else {
          vm.viewRequest.pagamentoEstaLiberado = true;
          vm.loadingValidacao = false;
        }
      }
    },
    500),
  },
};
